import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { DialogOverlayComponent } from '../../../../shared/components/dialog-overlay/components/dialog-overlay.component';
import { DialogOverlay } from '../../../../shared/services/dialog-overlay.services';
import { RequestBodyService } from '../../../../shared/services/request-body.service';
import { UserService } from '../../../../core/services/user.service';
import { AccountAttributesEnum } from '../../../../shared/enums';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: "app-job-title",
    templateUrl: "./job-title.component.html",
    styleUrls: ["./job-title.component.scss"],
    standalone: false
})
export class JobTitleComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() hideAdvancedSwitch: boolean = false;
  @Input() hideTitle: boolean = false;
  @Input() disabled: boolean = false;
  @Output("triggerSearch") triggerSearch = new EventEmitter();
  @Output() titleChanged: EventEmitter<void> = new EventEmitter<void>();
  searchType = "basic";
  hasBooleanAttribute: boolean = false;
  @ViewChild("jobTitleDialog") jobTitleDialog: DialogOverlayComponent;

  private jobTitleChange = new Subject<void>();

  constructor(
    public requestBody: RequestBodyService,
    private requestBodyService: RequestBodyService,
    private dialogOverlay: DialogOverlay,
    private userService: UserService,
  ) {
    this.jobTitleChange.pipe(
        debounceTime(500),
        untilDestroyed(this),
      ).subscribe(() => {
        this.titleChanged.emit();
      });
  }

  ngOnInit() {
    this.hasBooleanAttribute = this.userService.hasAccess(AccountAttributesEnum.BOOLEAN);
  }

  ngOnChanges(){
      this.hasBooleanAttribute = this.userService.hasAccess(AccountAttributesEnum.BOOLEAN);
      if ((this.data?.job_title_any?.length || this.data?.job_title_all?.length || this.data?.job_title_none?.length)
          && this.hasBooleanAttribute) {
          this.searchType = "advanced";
      } else {
          this.searchType = "basic";
      }
  }

  isValidJobTitle(job_title_type) {
    if (
      this.data[job_title_type].split(",").filter((item) => item.trim().length > 0)
        .length <= 0
    ) {
      this.data[job_title_type] = "";
    }
    this.requestBodyService.universalFilterChanged.next(this.data);
    this.onJobTitleChange();
  }

    preventDefaultBehaviour(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            this.triggerSearch.emit();
        }
    }

  toggleSearchType(event, searchType) {
    event.preventDefault();
    if (searchType == "basic") {
      if (this.data?.job_title_all?.length || this.data?.job_title_none?.length) {
        this.dialogOverlay
          .show(
            this.jobTitleDialog,
            "By switching views, information you’ve entered will be cleared.",
            "location-section"
          )
          .then((res) => {
            this.data.job_title = this.data.job_title_any;
            this.clearField('job_title_any');
            this.clearField('job_title_all');
            this.clearField('job_title_none');
            this.searchType = searchType;
            this.onJobTitleChange();
          })
          .catch((err) => {});
      } else {
        this.data.job_title = this.data.job_title_any;
        this.clearField('job_title_any');
        this.clearField('job_title_all');
        this.clearField('job_title_none');
        this.searchType = searchType;
        this.onJobTitleChange();
      }
    } else {
        this.data.job_title_any = this.data.job_title;
        this.clearField('job_title');
        this.searchType = searchType;
        this.onJobTitleChange();
    }
  }

  private clearField(field: string): void {
    if (!this.data) return;
    this.data[field] = "";
    if (this.data.reset && typeof this.data.reset === 'function') {
      this.data.reset(field);
    }
  }

  onJobTitleChange() {
    this.jobTitleChange.next();
  }

}
